<div class="modal-header" id="confirmation-material-stock-modal-title">
    <h3 class="modal-title">{{ cseHeader }}</h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form class="confirmationMaterialAddStockForm" [formGroup]="confirmationMaterialStockForm">
        <fieldset formArrayName="formChildren">
            <div class="container-fluid">
                <div class="row mb-3 align-items-center">
                    <label
                        class="col-12 fw-bold text-start p-0"
                        for="materialNumber"
                        translate="CONFIRMATION_MATERIAL_CSE_STOCK_MATNO"
                    ></label>
                    <div class="col-12 p-0 mb-3">
                        <pace-core-text-input
                            id="materialNumber"
                            name="materialNumber"
                            [(model)]="model.materialNumber"
                            [parentForm]="confirmationMaterialStockFormChildren"
                            (valueChange)="validateForm()"
                            [ariaLabel]="'CONFIRMATION_MATERIAL_CSE_STOCK_MATNO' | translate"
                        ></pace-core-text-input>
                    </div>
                    <ng-container *ngIf="!isBootStock">
                        <label
                            class="col-12 fw-bold text-start p-0"
                            for="storageLocation"
                            translate="CONFIRMATION_MATERIAL_CSE_STOCK_STORAGE_LOCATION"
                        ></label>
                        <div class="col-12 p-0 d-flex w-100">
                            <pace-core-text-input
                                id="storageLocation"
                                name="storageLocation"
                                [(model)]="model.storageLocation"
                                [parentForm]="confirmationMaterialStockFormChildren"
                                class="flex-grow-1"
                                [ariaLabel]="'CONFIRMATION_MATERIAL_CSE_STOCK_STORAGE_LOCATION' | translate"
                            ></pace-core-text-input>
                            <button
                                id="btnStockSearch"
                                type="button"
                                class="btn btn-primary ms-2"
                                translate="CONFIRMATION_MATERIAL_CSE_STOCK_SEARCH"
                                (click)="searchStock()"
                            ></button>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="isBootStock">
                        <label
                            class="col-12 fw-bold text-start p-0"
                            for="materialDescription"
                            translate="CONFIRMATION_MATERIAL_CSE_STOCK_MATERIAL_DESCRIPTION"
                        ></label>
                        <div class="col-12 mb-3 mb-lg-0 p-0">
                            <pace-core-text-input
                                id="materialDescription"
                                name="materialDescription"
                                [(model)]="model.materialDesc"
                                [parentForm]="confirmationMaterialStockFormChildren"
                                [ariaLabel]="'CONFIRMATION_MATERIAL_CSE_STOCK_MATERIAL_DESCRIPTION' | translate"
                            ></pace-core-text-input>
                        </div>
                    </ng-container>
                </div>
                <div class="row table-header fw-bold py-2">
                    <div class="col-4 offset-1" (click)="setOrderBy('materialIdentifier.materialNumber.value')">
                        <span translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_MATNO"> </span>
                        <span
                            class="sort-order"
                            *ngIf="orderField === 'materialIdentifier.materialNumber.value'"
                            [ngClass]="{ reverse: isReverse }"
                        ></span>
                    </div>
                    <div class="col-4" (click)="setOrderBy('description.value')">
                        <span translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_MATERIAL_DESC"></span>
                        <span
                            class="sort-order"
                            *ngIf="orderField === 'description.value'"
                            [ngClass]="{ reverse: isReverse }"
                        ></span>
                    </div>
                    <div class="col-3" (click)="setOrderBy('deliveredQuantity')">
                        <span translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_QUANTITY"></span>
                        <span
                            class="sort-order"
                            *ngIf="orderField === 'deliveredQuantity'"
                            [ngClass]="{ reverse: isReverse }"
                        ></span>
                    </div>
                </div>
                <div class="material-stock-content">
                    <div
                        class="row table-row"
                        *ngFor="
                            let material of filteredMaterials(model.cseMaterialStocks) | orderBy: orderField : isReverse
                        "
                    >
                        <pace-confirmation-material-stock-details-expandable
                            [material]="material"
                            [isModelNotification]="model.notification"
                        ></pace-confirmation-material-stock-details-expandable>
                    </div>
                </div>
            </div>
        </fieldset>
    </form>
</div>
<div class="modal-footer" id="modal-footer">
    <progressbar *ngIf="isSearchingOtherBootStock || isPickingOtherStock" [value]="100" type="default"> </progressbar>
    <label class="form-control-plaintext text-center text-lg-start">
        <span [innerHTML]="offlineMessage"></span>
        {{ dateTime }}
    </label>
    <button
        *ngIf="model.notification && !isSearchingOtherBootStock && !isPickingOtherStock"
        class="btn btn-primary col-12 col-md-4 col-lg-2"
        [disabled]="!isMaterialSelected()"
        (click)="pickupFromStock()"
        translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_PICKUP"
    ></button>
</div>
